import React from "react";
import Preloader from "../helper/Preloader";
import ColorInit from "../helper/ColorInit";
import HeaderTwo from "../components/HeaderTwo";
import Breadcrumb from "../components/Breadcrumb";
import FooterTwo from "../components/FooterTwo";
import BottomFooter from "../components/BottomFooter";
import ShippingOne from "../components/ShippingOne";
import Checkout from "../components/OrderConfirm";
import ScrollToTop from "react-scroll-to-top";
import { Helmet } from "react-helmet-async";

const CheckoutPage = () => {
  return (
    <>
      <Helmet>
        <title>Order Confirmed | Awaneez</title>
      </Helmet>
      {/* ColorInit */}
      <ColorInit color={true} />

      {/* ScrollToTop */}
      <ScrollToTop smooth color="#2694e9" />

      {/* HeaderTwo */}
      <HeaderTwo category={true} />

      {/* Checkout */}
      <Checkout />

      {/* FooterTwo */}
      <FooterTwo />
    </>
  );
};

export default CheckoutPage;
